<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('Select customer information') }}</h4>
    </div>
    <div class="modal-body">
      <div class="customer-types">
        <div class="customer-type">
          <div class="btn-group">
            <label>
              <input type="radio" name="customertype" v-model="customerType" :value="TYPE_CLIENT" v-on:click="customerTypeChanged"> {{ _('Private customer') }}
            </label>
          </div>
        </div>
        <div class="customer-type">
          <div class="btn-group">
            <label>
              <input type="radio" name="customertype" v-model="customerType" :value="TYPE_BILLINGCUSTOMER" v-on:click="customerTypeChanged"> {{ _('Company or organization') }}
            </label>
          </div>
        </div>
      </div>
      <div class="container-fluid customer-list">
        <customer-search v-if="customerType === TYPE_CLIENT" :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" v-on:selectCustomer="selectCustomer" />
        <billingcustomer-search v-else v-on:selectCustomer="selectCustomer" :baseDomain="baseDomain" :shopId="shopId" :apiKey="apiKey" v-on:selectBillingcustomer="selectBillingcustomer" />
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button class="btn btn-success" v-on:click="select" :disabled="!isOkButtonEnabled"><i class="fa fa-fw fa-check"></i> {{ _('OK') }}</button>
    </div>
  </div>
</template>

<script>

import constants from '~/lib/constants'
import { CustomerSearch, BillingcustomerSearch } from '#components'

export default {
  mixins: [constants],
  props: ['baseDomain', 'shopId', 'apiKey', 'mode'],
  data () {
    return {
      TYPE_CLIENT: 0,
      TYPE_BILLINGCUSTOMER: 1,
      customerType: 0,
      selectedCustomer: null,
      selectedBillingcustomer: null
    }
  },
  computed: {
    isOkButtonEnabled () {
      return !!this.selectedCustomer
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    customerTypeChanged () {
      this.selectedCustomer = null
      this.selectedBillingcustomer = null
    },
    selectCustomer (customer) {
      this.selectedCustomer = customer
    },
    selectBillingcustomer (customer) {
      this.selectedBillingcustomer = customer
    },
    select () {
      this.$emit('select', { customer: this.selectedCustomer, billingCustomer: this.selectedBillingcustomer })
    },
  },
  created () {
    if (this.mode === 'client') {
      this.customerType = this.TYPE_CLIENT
    } else {
      this.customerType = this.TYPE_BILLINGCUSTOMER
    }
  },
  components: {
    CustomerSearch,
    BillingcustomerSearch
  }
}
</script>
